/* eslint-disable */
import stripIndent from '../../Vendor/strip-indent';

/**
 * Thrown logging in a mockuser failed
 * @export
 * @class AuthLoggedInButStatusNotSuccess
 * @extends {Error}
 */
export class AuthLoggedInButStatusNotSuccess extends Error {
  /**
   * Creates an instance of AuthLoggedInButStatusNotSuccess
   * @param {string} message The Error `message`
   * @memberof AuthLoggedInButStatusNotSuccess
   */
  constructor(message) {
    super(message);
    this.name = `AuthLoggedInButStatusNotSuccess`;
  }
}

/**
 * Called logging in a user failed
 * @param {string} status The status
 * @returns {never} never
 */
const throwAuthLoggedInButStatusNotSuccess = (status) => {
  throw new AuthLoggedInButStatusNotSuccess(
    stripIndent(`
    Login was successful but status is not equal to SUCCESS. Status = ${status}
    `),
  );
};

export default throwAuthLoggedInButStatusNotSuccess;
